import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import SectionGate from '../../../app/SectionGate';
import { AdminDispatch } from '../../../app/store';
import { AdminState } from '../../../reducers';
import { initialize } from '../state/appSlice';
import LandingZonesWrapper from './LandingZonesWrapper';

const useInitialize = (dispatch: AdminDispatch) => {
  useEffect(() => {
    (async () => {
      const resultAction = await dispatch(initialize());
      if (initialize.rejected.match(resultAction)) {
        throw new Error(resultAction.error.message);
      }
    })();
  }, [dispatch]);
};

// Init gate for the landing-zones section. Acts as a route layout:
// the section's page lives in the consolidated route table (app/Main.tsx) and
// renders through the <Outlet /> that SectionGate provides once initialized.
const App: React.FC = () => {
  const dispatch = useDispatch<AdminDispatch>();
  const { initialized, initializing, initError } = useSelector(
    (state: AdminState) => state.landingZones,
  );
  useInitialize(dispatch);

  return (
    <SectionGate
      initializing={initializing}
      initialized={initialized}
      hasError={!!initError}
      wrapper={LandingZonesWrapper}
    />
  );
};

export default App;
